enum DirectoryStatus {
  Hide = 'Hide from Directory',
  Submit = 'Submit for Directory Review',
  Pending = 'Pending Directory Approval',
  Approved = 'Approved for Directory',
}

export default DirectoryStatus;
